export enum EntityType {
    User = 0,
    Manager = 10,
    Investor = 20,
    Nominee = 30,
    Partnership = 40,
    UnitisedFund = 50,
    Consols = 60,
    Group = 70,
}

export enum EntitySubType {
    User = 0,
    Manager = 100,
    Advisor = 110,
    Investor = 200,
    NotifiedForeignInvestor = 210,
    KiwiSaverInvestor = 220,
    Nominee = 300,
    Custodian = 310,
    PIP = 320,
    Partnership = 400,
    LimitedLiabilityPartnership = 410,
    UnitTrust = 500,
    PIEFund = 510,
    Consols = 600,
    Group = 700
}